<template>
  <v-container>

    <v-toolbar flat dense>
      <v-toolbar-title>Systems</v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <v-btn icon>
        <v-icon>mdi-cog</v-icon>
      </v-btn> -->

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon @click="snackbar_visible = true" v-bind="attrs" v-on="on">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </template>
        <span>Add New</span>
      </v-tooltip>

      <v-menu bottom right offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item
            v-for="(item, i) in menu_items"
            :key="i"
            @click="snackbar_visible = true"
          >
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

    </v-toolbar>

    <v-card flat rounded="false">
      <v-card-title>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        class="row-pointer"
        :headers="headers"
        :items="projects"
        :items-per-page="-1"
        :search="search"
        @click:row="handleClick"
        dense
        mobile-breakpoint="0"
      >
        <template v-slot:item.Summary.LastScan="{ item }">
          {{formatDate(item.Summary.LastScan)}}
        </template>
        <template v-slot:item.Summary.Counts="{ item }">
          <apexchart
            align="justify"
            height="50"
            width="500"
            :options="risksOptions"
            :series="item.Summary.Counts"
          />
        </template>
      </v-data-table>
    </v-card>
    <v-snackbar color="error" v-model="snackbar_visible" :timeout="snackbar_timeout">
      {{ snackbar_text }}
      <template v-slot:action="{ attrs }">
        <v-btn
          plain
          snackbar_text
          v-bind="attrs"
          @click="snackbar_visible = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>
<script>
import router from "../router.js";
import { demoData } from '../a9n-testdata.js'
import { chartColorArray } from "../common/Labels.js"
import { DateTime } from 'luxon'

export default {
  data() {
    return {
      snackbar_visible: false,
      snackbar_text: "Demo instance - functionality disabled",
      snackbar_timeout: 2000,
      menu_items: [{ title: "Global Configuration" }],
      search: "",
      headers: [
        {
          text: "Target",
          align: "start",
          value: "Project",
        },
        { text: "Scanners Used", value: "Summary.Scans.length" },
        { text: "Last Scan", value: "Summary.LastScan" },
        // TODO custom sort
        { text: "Risks", value: "Summary.Counts", sortable: false, align: ' d-none d-sm-table-cell' },
      ],
      projects: demoData.Projects,
      risksOptions: {
        chart: {
          type: "bar",
          stacked: true,
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: true,
          },
        },
        fill: {
          opacity: 1,
        },
        xaxis: {
          floating: true,
          min: 0,
          max: 40,
          axisTicks: {
            show: false,
          },
          axisBorder: {
            show: false,
          },
          labels: {
            show: false,
          },
        },
        yaxis: {
          floating: true,
          axisTicks: {
            show: false,
          },
          axisBorder: {
            show: false,
          },
          labels: {
            show: false,
          },
        },
        legend: {
          show: false,
        },
        grid: {
          show: false,
          padding: {
            top: -10,
            bottom: 0
          }
        },
        colors: chartColorArray,
      },
    };
  },
  methods: {
    handleClick(item) {
      router.push({ name: "assessment", params: { assessmentId: item.AID } });
    },
    formatDate(secs) {
      return DateTime.fromSeconds(secs).setLocale('en-GB').toLocaleString(DateTime.DATE_MED)
    }
  },
};
</script>
<style lang="css" scoped>
.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}
</style>
